import * as React from 'react';
import {BasePureComponent} from './BaseComponent';
import {Trad} from './';
import * as Dati from '../Dati';
import * as DatiRCP from '../DatiRCP';
import * as Glob from '../Globale';
import {CheckListFile} from '../components/';

interface IAccordionInformazioniAccessorieProps extends Dati.IBaseProps {
    FileJSON: Glob.DatiJSON;
    Abilitato: boolean;
    Indice: number;
    ID_Polizza: number;
    Chiavi: number[];
    ID_TipoFileRichiesto: string;
}

export class AccordionInformazioniAccessorie extends BasePureComponent<IAccordionInformazioniAccessorieProps> {

    public constructor(props: any) {
        super(props);
    }

    public render() {
        return <div className="kt-accordion__item">
            <a href={"#kt_accordion_1_item_" + this.props.Indice + "_body"}
               className="kt-accordion__item-head arrow collapsed" role="tab"
               id={"kt_accordion_1_item_" + this.props.Indice + "_head"} data-toggle="collapse"
               aria-expanded="false">
                <span className="accordion__item-icon"><i
                    className="fa fa-highlighter"></i></span>
                <span
                    className="accordion__item-icon">{Trad.Trad("InformazioniAccessorie")}</span>
                <span className="kt-accordion__item-mode"></span>
            </a>
            <div className="kt-accordion__itekt-body collapse" id="kt_accordion_1_item_6_body"
                 role="tabpanel"
                 aria-labelledby={"kt_accordion_1_item_" + this.props.Indice + "_head"}
                 data-parent="#kt_accordion_1">
                <div className="tab-content  kt--padding-60">
                    <div>
                        <div className="col-xl-12 offset-xl-0">
                            <div className="kt-form login-form__section kt-form login-form__section--first">
                                <CheckListFile Aggiornare={this.props.ID_Polizza} Id={this.props.Id}
                                               Name={this.props.Name}
                                               ID_Chiave={this.props.ID_Polizza}
                                               ChiaviRecupero={this.props.Chiavi}
                                               ID_TipoFileRichiesto={this.props.ID_TipoFileRichiesto || ""}
                                               Value={this.props.FileJSON}
                                               OnChange={this.props.OnChange}
                                               Validato={false}
                                               Visibile={this.props.ID_Polizza > 0}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/AccordionInformazioniAccessorie.tsx